export default __webpack_public_path__ + "static/media/piplhero.0cd1266e.gif";